import { Autocomplete, Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

import {
  Color,
  FontStyle,
  defaultBottomPadding,
  defaultInnerStyle,
  defaultContainerStyle,
} from "../../constants";
import CheckButton from "../CheckButton";
import HeartButton from "../HeartButton";
import TempDisplay from "../TempDisplay";
import { CustomPaper, StyledTextField } from "../AutocompleteUtils";
import { useSelector } from "react-redux";

const styles = {
  container: {
    ...defaultContainerStyle,
    px: { xs: "0.25rem", sm: 0 },
  },
  inner: {
    ...defaultInnerStyle,
  },
  body: {
    ...FontStyle.body,
    fontSize: "0.83rem",
    textAlign: "left",
    lineHeight: "1.4",
    maxWidth: "500px",
    "& > * >a": {
      color: "#000",
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    },
  },
  label: {
    ...FontStyle.headingBody,
    // fontSize: '0.83rem',
    fontSize: "1rem",
    // textAlign: 'center',
    lineHeight: "1.4",
    width: "100%",
    maxWidth: "500px",
  },
  search: {
    width: "100%",
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "4px",
    border: "1px solid rgb(204, 204, 204)",
  },
  info: {
    // borderLeft: `6px solid ${Color.primary}`,
    borderRadius: "0.75rem",
    backgroundColor: "#fff",
    // padding: '1.2rem',
  },
};
const numNeeded = 1;
const numMax = 600;
const numPronouns = 4;
const numGenders = 5;
const numEthnicities = 12;

const Q13_Demographic = ({
  selected,
  setSelected,
  setQuestionsDone,
  questionNum,
  options,
}) => {
  const serverRefreshes = useSelector((state) => state.survey.serverRefreshes);
  useEffect(() => {
    setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }));
  }, [selected]);
  const [pronounIdx, setPronounIdx] = useState(null);
  const [genderIdxs, setGenderIdxs] = useState([]);
  const [ethnicityIdxs, setEthnicityIdxs] = useState([]);
  useEffect(() => {
    setSelected((s) => {
      return {
        ...s,
        [questionNum]: [
          ...(pronounIdx !== null ? [pronounIdx] : []),
          ...genderIdxs,
          ...ethnicityIdxs,
        ],
      };
    });
  }, [pronounIdx, genderIdxs, ethnicityIdxs]);
  // sync values from server
  useEffect(() => {
    if (serverRefreshes === 0) return;
    let newPronounIdx = null;
    let newGenderIdxs = [];
    let newEthnicityIdxs = [];
    selected[questionNum].map((idx) => {
      if (idx < numPronouns) {
        newPronounIdx = idx;
      } else if (idx < numPronouns + numGenders) {
        newGenderIdxs.push(idx);
      } else {
        newEthnicityIdxs.push(idx);
      }
    });
    setPronounIdx(newPronounIdx);
    setGenderIdxs(newGenderIdxs);
    setEthnicityIdxs(newEthnicityIdxs);
  }, [serverRefreshes]);
  return (
    <Stack
      direction="column"
      sx={styles.container}
      alignItems="center"
      spacing={4}>
      {/* <TempDisplay selected={selected} options={options} questionNum={questionNum} /> */}
      <Stack
        direction="column"
        sx={styles.inner}
        alignItems="left"
        justifyContent="center"
        spacing={1}>
        <Box sx={styles.label}>Pronouns</Box>
        <Autocomplete
          options={options.slice(0, numPronouns)}
          getOptionLabel={(option) => option}
          // defaultValue={options[pronounIdx]}
          value={pronounIdx !== null ? options[pronounIdx] : null}
          onChange={(event, newValue) => {
            setPronounIdx(options.indexOf(newValue));
          }}
          sx={{
            width: "100%",
            "& .MuiFormControl-root": {
              border: "none",
            },
          }}
          PaperComponent={CustomPaper}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props} style={{ textAlign: "center", width: "100%" }}>
                <Box sx={{ margin: "auto" }}>{option}</Box>
              </li>
            );
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
              }}
              sx={styles.search}
              variant="standard"
              placeholder="Select..."
            />
          )}
        />
        <Box sx={{ ...styles.label, paddingTop: "1rem" }}>
          Gender identity (choose all that apply)
        </Box>
        <Autocomplete
          multiple
          options={options.slice(numPronouns, numPronouns + numGenders)}
          getOptionLabel={(option) => option}
          // defaultValue={options[pronounIdx]}
          value={options.filter((_, idx) => genderIdxs.includes(idx))}
          onChange={(event, newValue) => {
            setGenderIdxs(newValue.map((v) => options.indexOf(v)));
          }}
          sx={{
            width: "100%",
            "& .MuiFormControl-root": {
              border: "none",
            },
          }}
          PaperComponent={CustomPaper}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props} style={{ textAlign: "center", width: "100%" }}>
                <Box sx={{ margin: "auto" }}>{option}</Box>
              </li>
            );
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
              }}
              sx={styles.search}
              variant="standard"
              placeholder="Select..."
            />
          )}
        />
        <Box sx={{ ...styles.label, paddingTop: "1rem" }}>
          Ethnicity (choose all that apply)
        </Box>
        <Autocomplete
          multiple
          options={options.slice(
            numPronouns + numGenders,
            numPronouns + numGenders + numEthnicities
          )}
          getOptionLabel={(option) => option}
          value={options.filter((_, idx) => ethnicityIdxs.includes(idx))}
          onChange={(event, newValue) => {
            setEthnicityIdxs(newValue.map((v) => options.indexOf(v)));
          }}
          sx={{
            width: "100%",
            "& .MuiFormControl-root": {
              border: "none",
            },
          }}
          PaperComponent={CustomPaper}
          renderOption={(props, option, { selected }) => {
            return (
              <li {...props} style={{ textAlign: "center", width: "100%" }}>
                <Box sx={{ margin: "auto" }}>{option}</Box>
              </li>
            );
          }}
          renderInput={(params) => (
            <StyledTextField
              {...params}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
              }}
              sx={styles.search}
              variant="standard"
              placeholder="Select..."
            />
          )}
        />
        <Stack
          direction="column"
          sx={{
            ...styles.body,
            textAlign: "left",
            ...styles.inner,
            paddingTop: "38px",
            fontSize: "1rem",
            "& > * >a": {
              color: "#000",
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            },
          }}
          alignItems="center"
          justifyContent="center"
          spacing={1}>
          <Stack
            direction="row"
            sx={{ ...FontStyle.headingBody, textAlign: "left", width: "100%" }}
            alignItems="left">
            How we use this information:
          </Stack>
          <Stack direction="row" sx={{ width: "100%" }} alignItems="left">
            <Box sx={{ width: "30px", minWidth: "30px" }}>🔍</Box>
            <Box>This information will only be seen by Fetti.</Box>
          </Stack>
          <Stack direction="row" sx={{ width: "100%" }} alignItems="left">
            <Box sx={{ width: "30px", minWidth: "30px" }}>🙏</Box>
            It helps us figure out how to make the platform even more customized
            to users like you.
          </Stack>
          <Stack
            direction="row"
            sx={{
              width: "100%",
              "& > * >a": {
                color: "#000",
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              },
            }}>
            <Box sx={{ width: "30px", minWidth: "30px" }}>📝</Box>
            <Box>
              For further details on how we use your personal data, please refer
              to our{" "}
              <a href="/" style={{ fontWeight: "bold" }}>
                Privacy Policy
              </a>{" "}
              available here.
            </Box>
          </Stack>
        </Stack>

        {/* <Box sx={{
          paddingTop: 3,

          
        }}>
          <Stack direction='column' sx={{ ...styles.info, ...styles.body, fontSize: '1rem' }} spacing={2}>
            <Box sx={{ fontWeight: 'bold' }}>How we use this information:</Box>
            <Box sx={{}}>This information will only be seen by Fetti. It helps us figure out how to make the platform even more customized to users like you. For further details on how we use your personal data, please refer to our <a href='/' style={{ fontWeight: 'bold' }}>Privacy Policy</a> available here.</Box>
          </Stack>
        </Box> */}
      </Stack>
    </Stack>
  );
};

export default Q13_Demographic;
